import { message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MdOutlineContentCopy } from 'react-icons/md';

export function useCopyToClipboard({
    copiedMessage = 'Copied',
    copyError = 'Copy Error',
}: {
    copiedMessage?: string;
    copyError?: string;
}) {
    function copiedSuccessfully() {
        message.success({
            content: copiedMessage,
            className: 'response-copy',
            type: 'success',
        });
    }
    function onCopy(text: string) {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                copiedSuccessfully();
            })
            .catch(() => {
                message.error({
                    content: copyError,
                    className: 'response-error',
                    type: 'error',
                });
            });
    }

    function copyToClipboardAddOn(key: string) {
        return (
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    onCopy(key);
                }}
            >
                <CopyToClipboard text={key}>
                    <MdOutlineContentCopy className="w-6 h-5 fill-primary !pointer-events-auto !cursor-pointer hover:transform hover:scale-90 transition-all ease-in-out" />
                </CopyToClipboard>
            </div>
        );
    }
    return {
        onCopy,
        copiedSuccessfully,
        CopyToClipboard,
        copyToClipboardAddOn,
    };
}
